module.exports = __webpack_public_path__ + "img/card-i1.ebbae8d7.png";